// localStorage access that degrades to an in-memory map when localStorage is
// unavailable (private mode, quota, Node harness). All persistence goes
// through this so core modules never touch window directly.

export interface KVStorage {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

class MemoryStorage implements KVStorage {
  private map = new Map<string, string>();
  get(key: string) { return this.map.has(key) ? this.map.get(key)! : null; }
  set(key: string, value: string) { this.map.set(key, value); }
  remove(key: string) { this.map.delete(key); }
}

class BrowserStorage implements KVStorage {
  get(key: string) { try { return localStorage.getItem(key); } catch { return null; } }
  set(key: string, value: string) { try { localStorage.setItem(key, value); } catch { /* quota/private mode */ } }
  remove(key: string) { try { localStorage.removeItem(key); } catch { /* ignore */ } }
}

function hasLocalStorage(): boolean {
  try { return typeof localStorage !== "undefined" && localStorage != null; } catch { return false; }
}

export let storage: KVStorage = hasLocalStorage() ? new BrowserStorage() : new MemoryStorage();

/** Swap the backing store (tests / headless harness). */
export function setStorage(s: KVStorage) { storage = s; }
export function memoryStorage(): KVStorage { return new MemoryStorage(); }
